module.exports = __webpack_public_path__ + "img/stock2.18392e7a.png";